module.exports = __webpack_public_path__ + "img/9_26@3x.0bfd2c13.png";